import type { Project } from '../data/projectTypes'

// A project is "shared with you" when you are a member of it but not its owner — i.e. someone else's
// project you were invited to. The list/sidebar endpoints stamp each project row with the viewer's
// membership role (`user_role`, from project_members.role via listProjects); 'member' means shared.
// Detail views resolve the same role from the members query, so they pass a boolean directly to the
// badge rather than reading it off the project row.
export function isSharedProject(project: Pick<Project, 'user_role'>): boolean {
  return project.user_role === 'member'
}
